import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  makeStyles,
  Typography,
} from "@material-ui/core";
import moment from "moment";
import { Transformation, Image } from "cloudinary-react";

const useStyles = makeStyles((theme) => ({
  container: {
    flexDirection: "row",
    display: "flex",
    justifyContent: "space-between",
  },
  pictureContainer: {
    marginLeft: 30,
    marginTop: 20,
  },
  tableContainer: {
    flex: 1,
    [theme.breakpoints.up("lg")]: {
      maxWidth: "900px",
    },
  },
  table: {
    marginTop: 30,
  },
}));

const KornspeicherComponent = ({ reports, gemeinde }) => {
  const classes = useStyles();
  const gewerteteBerichte = reports
    ? reports.filter(
        (r) => r.freigabe && r.bewertungsende.seconds * 1000 < Date.now()
      )
    : null;
  const berichteInBewertung = reports
    ? reports.filter(
        (r) => r.freigabe && r.bewertungsende.seconds * 1000 > Date.now()
      )
    : null;
  return (
    <div className={classes.container}>
      <div className={classes.tableContainer}>
        {gewerteteBerichte ? (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <Typography variant="h6">Projekt</Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography variant="h6">Anz. Bewertungen</Typography>
                </TableCell>
                <TableCell align="right" size="small">
                  <Typography variant="h6">Bewertung</Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {gewerteteBerichte
                .sort(
                  (a, b) => a.bewertungsende.seconds - b.bewertungsende.seconds
                )
                .map((bericht) => (
                  <TableRow key={bericht.id}>
                    <TableCell scope="row">
                      <Typography variant="body2">{bericht.titel}</Typography>
                    </TableCell>
                    <TableCell scope="row" align="right">
                      <Typography variant="body2">
                        {bericht.anzBewGemeinden > 0
                          ? bericht.anzBewGemeinden === 1
                            ? bericht.anzBewertungen + " aus einer Gemeinde"
                            : bericht.anzBewertungen +
                              " aus " +
                              bericht.anzBewGemeinden +
                              " Gemeinden"
                          : null}
                      </Typography>
                    </TableCell>
                    <TableCell align="right" size="small">
                      <Typography variant="body2">
                        {bericht.value
                          ? bericht.value.toLocaleString(navigator.language, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : "1,00"}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))}
              <TableRow>
                <TableCell>
                  <Typography variant="body1" style={{ fontWeight: "bold" }}>
                    Füllstand Kornspeicher (Summe)
                  </Typography>
                </TableCell>
                <TableCell />
                <TableCell align="right">
                  <Typography variant="body1" style={{ fontWeight: "bold" }}>
                    {gemeinde.summe
                      ? gemeinde.summe.toLocaleString(navigator.language, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : "0,00"}
                  </Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        ) : null}
        {berichteInBewertung ? (
          <div>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Typography variant="h6">Projekte in Bewertung</Typography>
                  </TableCell>
                  <TableCell align="right" size="small">
                    <Typography variant="h6">Erntedatum *)</Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {berichteInBewertung
                  .sort(
                    (a, b) =>
                      a.bewertungsende.seconds - b.bewertungsende.seconds
                  )
                  .map((bericht) => (
                    <TableRow key={bericht.id}>
                      <TableCell scope="row">
                        <Typography variant="body2">{bericht.titel}</Typography>
                      </TableCell>
                      <TableCell align="right" size="small">
                        <Typography variant="body2">
                          {moment(
                            bericht.bewertungsende.seconds * 1000
                          ).calendar()}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
            <Typography variant="subtitle2" style={{ marginTop: 30 }}>
              *) Ende Bewertungszeitraum
            </Typography>
          </div>
        ) : null}
      </div>
      <div className={classes.pictureContainer}>
        <Image className={classes.logo} publicId="internal/saefrau.png">
          <Transformation
            quality="auto"
            radius="20"
            width="200"
            height="250"
            crop="fill"
          />
        </Image>
      </div>
    </div>
  );
};

export default KornspeicherComponent;
